<template>
  <ContentWrapperControl class="mt-4">
    <div class="bg-white h-full p-6 rounded shadow">
      <div class="flex flex-col items-center">
        <img
          class="papsi-mascot w-logo h-logo mx-auto"
          v-bind:src="getKalabaw()"
        />
        <span class="mt-8 text-primary font-bold text-4xl">{{
          lang("lbl_0000254")
        }}</span>
        <span class="mt-2 text-md font-semibold">{{
          lang("lbl_0000253")
        }}</span>
        <ButtonControl class="mt-8" @clicked="redirect">
          {{ lang("lbl_0000252") }}
        </ButtonControl>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "./../components/controls/ContentWrapperControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import mixin from "./../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    ButtonControl,
  },
  mounted() {
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000136"),
      show: true,
      back: true,
    });
    this.$emit("nofooter", true);
  },
  methods: {
    getKalabaw() {
      const path = "pia/images/elements/";
      const file_name = "papsi_kalabaw.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    redirect() {
      if (!this.$cookies.isKey("hash")) {
        this.destroyCookies();
        this.$router.push("/");
      } else {
        this.$router.push("/dashboard");
      }
    },
    clearCookies() {
      if (this.$cookies.isKey("hash")) {
        this.$cookies.remove("hash");
      }
    },
  },
};
</script>
